'use client';

import { createRoot, type Root } from 'react-dom/client';
import { useEffect, useState } from 'react';

let root: Root | null = null;
let setMsg: ((m: { text: string; type: 'success' | 'error' } | null) => void) | null = null;

function ToastContainer() {
  const [msg, _setMsg] = useState<{ text: string; type: 'success' | 'error' } | null>(null);
  useEffect(() => { setMsg = _setMsg; return () => { setMsg = null; }; }, []);
  useEffect(() => { if (!msg) return; const t = setTimeout(() => _setMsg(null), 3000); return () => clearTimeout(t); }, [msg]);
  if (!msg) return null;
  return (
    <div className="fixed inset-x-0 bottom-6 z-[100] flex justify-center pointer-events-none">
      <div
        className={[
          'pointer-events-auto px-5 py-3 rounded-xl text-sm font-medium shadow-lg animate-[slideUp_0.25s_ease-out]',
          msg.type === 'success'
            ? 'bg-emerald-600 text-white'
            : 'bg-red-600 text-white',
        ].join(' ')}
      >
        {msg.text}
      </div>
    </div>
  );
}

function ensure() {
  if (root) return;
  const div = document.createElement('div');
  div.id = '__sf-toast';
  document.body.appendChild(div);
  root = createRoot(div);
  root.render(<ToastContainer />);
}

function show(text: string, type: 'success' | 'error') {
  ensure();
  // wait a tick for mount on first call
  if (setMsg) setMsg({ text, type });
  else requestAnimationFrame(() => setMsg?.({ text, type }));
}

export const toast = {
  success: (text: string) => show(text, 'success'),
  error: (text: string) => show(text, 'error'),
  danger: (text: string) => show(text, 'error'),
};
